module.exports = __webpack_public_path__ + "stockLibrary/name-card-img-de73cac0dbb7d5976c3a0c43b299ecf2.svg";